import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Installment } from './installment';
import { Cashback } from './cashback';
import { Price } from './price';

const Text = styled.p`
  font-size: ${props => (props.isFloating ? `12px` : `14px`)};
`;

const PaymentOption = ({ isFloating, payment, showPrice }) => (
  <Text isFloating={isFloating}>
    {showPrice && (
      <>
        <Price payment={payment} />
        &nbsp;
      </>
    )}
    <Installment payment={payment} />
    &nbsp;
    <Cashback payment={payment} />
  </Text>
);

PaymentOption.defaultProps = {
  isFloating: false,
  showPrice: false,
};

PaymentOption.propTypes = {
  payment: PropTypes.object,
  showPrice: PropTypes.bool,
  isFloating: PropTypes.bool,
};

export default PaymentOption;
